import { OfferingCard } from '@ole-ui/ole-ui-components';
import React from 'react';
import {
  EmptyState,
  EmptyStateBody,
  EmptyStateHeader,
  EmptyStateIcon,
} from '@patternfly/react-core';
import SadIcon from '@patternfly/react-icons/dist/esm/icons/outlined-sad-tear-icon';
import { useTranslation } from 'react-i18next';

export default function OfferingCardFallback() {
  const { t } = useTranslation();
  return (
    <OfferingCard className="offering-card-builder">
      <EmptyState>
        <EmptyStateHeader
          titleText={t('Something went wrong')}
          headingLevel="h4"
          icon={<EmptyStateIcon icon={SadIcon} />}
        />
        <EmptyStateBody>{t('Could not load this offering.')}</EmptyStateBody>
      </EmptyState>
    </OfferingCard>
  );
}
